import { MessageCircle, MapPin, ShieldCheck, Sparkles } from "lucide-react";
import { BUSINESS, IMAGES } from "../lib/data";
import { useContact } from "../contexts/ContactContext";

export const Hero = () => {
  const { openGate } = useContact();
  
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative w-full overflow-hidden"
    >
      {/* background image */}
      <div className="absolute inset-0">
        <img
          src={IMAGES.hero}
          alt="Mehdi Soap Center traditional shop"
          loading="eager"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0B1733]/85 via-[#0B1733]/70 to-[#0B1733]/35" />
      </div>

      <div className="relative msc-container py-20 sm:py-28 lg:py-36">
        <div className="max-w-2xl text-white msc-fade-up">
          <span
            className="inline-flex items-center gap-2 bg-[#F59E0B] text-[#1F2937] px-3 py-1.5 rounded-full text-xs font-black uppercase tracking-wider shadow-md"
            data-testid="hero-since-badge"
          >
            <Sparkles className="w-3.5 h-3.5" /> Since 1971 · Bhiwandi’s Bharosa
          </span>

          <h1 className="mt-5 font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Bhiwandi ka <span className="text-[#FBBF24]">Sabse Purana</span>
            <br /> Cleaning Store.
          </h1>

          <p className="mt-5 text-base sm:text-lg text-white/90 max-w-xl">
            Detergent, sabun, phenyl, cleaning equipments — sab kuch ek chhat ke neeche.
            Hamare <span className="font-semibold text-[#FBBF24]">handmade soaps</span>{" "}
            ghar par hi banate hain — sasta daam, asli mehnat, 54 saal ka bharosa.
          </p>

          <div className="mt-7 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <button
              onClick={() => openGate()}
              data-testid="hero-whatsapp-btn"
              className="btn-whatsapp text-base"
            >
              <MessageCircle className="w-5 h-5" /> Order Now
            </button>
            <a
              href="#locations"
              data-testid="hero-visit-btn"
              className="inline-flex items-center justify-center gap-2 bg-white/95 hover:bg-white text-[#1E3A8A] rounded-md px-6 py-3 font-semibold shadow-md active:scale-[0.98] transition-all min-h-[48px]"
            >
              <MapPin className="w-5 h-5" /> Dukaan Pe Aaiye
            </a>
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3 text-sm text-white/85">
            <span className="inline-flex items-center gap-2">
              <ShieldCheck className="w-4 h-4 text-[#FBBF24]" /> 54+ Saal Trusted
            </span>
            <span className="inline-flex items-center gap-2">
              <Sparkles className="w-4 h-4 text-[#FBBF24]" /> Locally Manufactured
            </span>
            <span className="inline-flex items-center gap-2">
              <MapPin className="w-4 h-4 text-[#FBBF24]" /> 3 Stores in Bhiwandi
            </span>
          </div>
        </div>

        {/* Floating wholesale chip */}
        <a
          href="#wholesale"
          data-testid="hero-wholesale-chip"
          className="hidden md:inline-flex absolute right-6 lg:right-10 bottom-10 items-center gap-3 bg-white text-[#1F2937] px-5 py-4 rounded-2xl shadow-2xl hover:-translate-y-0.5 transition-transform max-w-[260px]"
        >
          <div className="w-11 h-11 rounded-xl bg-[#F59E0B]/20 text-[#B45309] flex items-center justify-center font-display font-black">
            ₹
          </div>
          <div className="leading-tight">
            <div className="font-display font-bold text-sm">Wholesale Buyers</div>
            <div className="text-xs text-[#4B5563] mt-0.5">
              Special bulk rates →
            </div>
          </div>
        </a>
      </div>

      {/* curved bottom */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg
          viewBox="0 0 1440 60"
          preserveAspectRatio="none"
          className="w-full h-[40px] sm:h-[60px]"
          aria-hidden="true"
        >
          <path d="M0,60 C480,0 960,0 1440,60 L1440,60 L0,60 Z" fill="#FAFAF9" />
        </svg>
      </div>
    </section>
  );
};
